const item = (sku, description, quantity, _catalogPrice, extra = {}) => ({
  sku,
  description,
  quantity,
  ...extra,
});

export const misc = [
  {
    slug: "medium-duty-cutlery",
    name: "Medium-Duty Cutlery",
    category: "misc",
    items: [
      item("MDF", "Forks – Unwrapped – White or Black", 1000, 8),
      item("MDTS", "Teaspoons – Unwrapped – White or Black", 1000, 8),
      item("MDSS", "Soup spoons – Unwrapped – White or Black", 1000, 8),
      item("MDK", "Knives – Unwrapped – White or Black", 1000, 8),
      item(
        "MDKFSN",
        "Wrapped set: knife, fork, spoon, napkin – White",
        250,
        12,
      ),
      item(
        "MDKFSNSP",
        "Wrapped set: knife, fork, spoon, napkin, salt & pepper – White",
        250,
        15,
      ),
    ],
  },
  {
    slug: "heavy-duty-cutlery",
    name: "Heavy-Duty Cutlery",
    category: "misc",
    items: [
      item("HDF", "Forks – Unwrapped – White or Black", 1000, 18),
      item("HDTS", "Teaspoons – Unwrapped – White or Black", 1000, 18),
      item("HDSS", "Soup spoons – Unwrapped – White or Black", 1000, 18),
      item("HDK", "Knives – Unwrapped – White or Black", 1000, 18),
      item("HDWF", "Forks – Individually wrapped – Black", 1000, 20),
      item("HDWTS", "Teaspoons – Individually wrapped – Black", 1000, 20),
      item(
        "HDKFSN",
        "Wrapped set: knife, fork, spoon, napkin – Black",
        250,
        17,
      ),
      item(
        "HDKFSNSP",
        "Wrapped set: knife, fork, spoon, napkin, salt & pepper – Black",
        250,
        20,
      ),
    ],
  },
  {
    slug: "chopsticks",
    name: "Chopsticks",
    category: "misc",
    items: [
      item("BC2000-HD", 'Heavy-duty 9" twin-wrapped chopsticks', 1600, 45),
    ],
  },
  {
    slug: "napkins",
    name: "Napkins & Dispenser",
    category: "misc",
    items: [
      item("BevNap", '9"x9" 1-ply beverage napkins', 4000, 15),
      item("LunNap", '13"x12" 1-ply lunch napkins', 6000, 35),
      item("DinNap", '15"x17" 2-ply dinner napkins', 3000, 32),
      item("TallNap", '7"x13.5" 2-ply tallfold dispenser napkins', 10000, 32),
      item("InterNap", '6.5"x8.5" interfold dispenser napkins', 6000, 32),
      item("InterNapDisp", "Interfold napkin dispenser", 1, 15),
    ],
  },
  {
    slug: "receipt-paper",
    name: "Receipt Paper",
    category: "misc",
    items: [
      item(
        "TP318230",
        "3⅛\" x 230' thermal paper roll with 13/17 mm plastic core",
        50,
        50,
        { unitLabel: "rolls" },
      ),
    ],
  },
  {
    slug: "aluminum-foil",
    name: "Aluminum Foil",
    category: "misc",
    items: [
      item("121000R", "Foil roll – 12\"x1000' – Standard Duty", 1000, 30, {
        unitLabel: "ft",
      }),
      item("18500HD", "Foil roll – 18\"x500' – Heavy Duty", 500, 30, {
        unitLabel: "ft",
      }),
      item("0910P", 'Foil popup sheets – 9"x10.75" – Pack', 500, 13, {
        unitLabel: "sheets",
      }),
      item("0910C", 'Foil popup sheets – 9"x10.75" – Case', 3000, 65, {
        unitLabel: "sheets",
      }),
      item("1210P", 'Foil popup sheets – 12"x10.75" – Pack', 500, 15, {
        unitLabel: "sheets",
      }),
      item("1210C", 'Foil popup sheets – 12"x10.75" – Case', 3000, 75, {
        unitLabel: "sheets",
      }),
    ],
  },
  {
    slug: "food-film",
    name: "Food Film",
    category: "misc",
    items: [
      item("122000Film", "12\"x2000' film with cutter box", null, 14),
      item("182000Film", "18\"x2000' film with cutter box", null, 17),
      item("242000Film", "24\"x2000' film with cutter box", null, 24),
    ],
  },
  {
    slug: "nitrile-gloves",
    name: "Nitrile Gloves",
    category: "misc",
    description: "Available in Small, Medium, Large, and X-Large.",
    items: [
      item("GLP", "3.5 mil gloves – Pack", 100, 7),
      item("GLC", "3.5 mil gloves – Case (10 packs)", 1000, 45),
      item("5mGLP", "5 mil gloves – Pack", 100, 9),
      item("5mGLC", "5 mil gloves – Case (10 packs)", 1000, 60),
    ],
  },
  {
    slug: "vinyl-gloves",
    name: "Vinyl Gloves",
    category: "misc",
    description: "Available in Medium, Large, and X-Large.",
    items: [
      item("VGP", "Vinyl gloves – Pack", 100, 3),
      item("VG", "Vinyl gloves – Case (10 packs)", 1000, 20),
    ],
  },
];
